<!-- <mat-toolbar color="primary">
  <mat-toolbar-row>
    <div class="links">
      <button mat-raised-button color="warn" routerLink="/admin/posts">POSTS</button>
      <button mat-raised-button color="warn" routerLink="/admin/destinos">DESTINOS INTELIGENTES</button>
      <button mat-raised-button color="warn" routerLink="/admin/contactos">CONTACTOS</button>
      <button mat-raised-button color="warn" routerLink="/admin/calendario">CALENDARIO</button>
    </div>
    <span class="spacer"></span>

    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="logOut()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Cerrar Sesión</span>
      </button>
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar> -->

<mat-toolbar color="primary">
  <mat-toolbar-row>
    <!-- Desktop links -->
    <div class="links desktop">
      <button mat-raised-button color="warn" routerLink="/admin/posts">POSTS</button>
      <button mat-raised-button color="warn" routerLink="/admin/destinos">DESTINOS</button>
      <button mat-raised-button color="warn" routerLink="/admin/contactos">CONTACTOS</button>
      <button mat-raised-button color="warn" routerLink="/admin/calendario">CALENDARIO</button>
    </div>

    <span class="spacer"></span>

    <!-- Mobile menu -->
    <button mat-icon-button class="mobile" [matMenuTriggerFor]="navMenu">
      <mat-icon>menu</mat-icon>
    </button>

    <mat-menu #navMenu="matMenu">
      <button mat-menu-item routerLink="/admin/posts">POSTS</button>
      <button mat-menu-item routerLink="/admin/destinos">DESTINOS</button>
      <button mat-menu-item routerLink="/admin/contactos">CONTACTOS</button>
      <button mat-menu-item routerLink="/admin/calendario">CALENDARIO</button>
    </mat-menu>

    <!-- user menu -->
    <button mat-icon-button [matMenuTriggerFor]="userMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #userMenu="matMenu">
      <button mat-menu-item (click)="logOut()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Cerrar sesión</span>
      </button>
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>

